@if (showHeader) {
    <app-header [showMenu]="true"></app-header>
}
@if (showBack) {
    <a mat-button class="goBack fade-in" (click)="goBack()">
        <mat-icon>keyboard_arrow_left</mat-icon>
        {{ 'account.back' | transloco }}
    </a>
}
<br/>
<!--<app-video-link *ngIf="showHeader" class="pull-right" videoLink="/help/download"></app-video-link>-->
<span style="padding: 30px; font-size: 2em">
  <mat-icon style="position: relative; top: 5px">download</mat-icon>
    {{ headerText1 }}
</span>
<br/>
<span style="padding: 30px; font-size: 1em">
  {{ headerText2 }}
</span>
<br/>
<br/>
@if (showPlayer) {
    <div class="tab-buttons">
        <button mat-raised-button class="tab-button" [class.active]="tabIndex === 0" (click)="go('0')">
            <mat-icon>edit</mat-icon>
            <span>{{ 'account.studio' | transloco }}</span>
        </button>
        <button mat-raised-button class="tab-button" [class.active]="tabIndex === 1" (click)="go('1')">
            <mat-icon>tv</mat-icon>
            <span>{{ 'account.player' | transloco }}</span>
        </button>
    </div>
}
<ngx-flicking [options]="{ circular: false, duration: 800, autoResize: true }" [plugins]="plugins">
    <div flicking-panel class="panel">
        <br/>
        <br/>
        <app-studio-download></app-studio-download>
    </div>
    <div flicking-panel class="panel">
        <br/>
        <div class="form-main">
            <!-- Hero Section -->
            <div class="hero-section">
                <div class="hero-icon">
                    <mat-icon>tv</mat-icon>
                </div>
                <h1 class="hero-title">SignPlayer</h1>
                <p class="hero-subtitle">Digital Signage & Touch Player</p>
            </div>

            <!-- Main Download Button -->
            <div class="main-download-section">
                <button mat-raised-button color="warn" class="downloadMainBut" (click)="download('player_sign_chrome')">
                    <mat-icon>tv</mat-icon>
                    <span>Download SignPlayer</span>
                    <span class="platform-text">All Operating Systems</span>
                </button>
            </div>

            <!-- Additional Options Cards -->
            <div class="options-section">
                <div class="option-card highlight-card" (click)="download('mediadroid')">
                    <mat-icon class="option-icon">router</mat-icon>
                    <div class="option-content">
                        <h4>mediaDROID+</h4>
                        <p>or purchase the media player, 100% plug & play, easy to start and delivers best performance for Signage/touch</p>
                    </div>
                    <mat-icon class="arrow-icon">arrow_forward</mat-icon>
                </div>

                <div class="option-card" (click)="download('device_compatability')">
                    <mat-icon class="option-icon">devices</mat-icon>
                    <div class="option-content">
                        <h4>Google TV & Fire TV</h4>
                        <p>Installation guide for TV devices</p>
                    </div>
                    <mat-icon class="arrow-icon">arrow_forward</mat-icon>
                </div>
            </div>

            <!-- SignService Section -->
            <div class="section-divider">
                <mat-icon>settings</mat-icon>
                <h3>SignService</h3>
                <p>Auto starts, monitors and restarts player</p>
            </div>

            <div class="service-cards">
                <div class="service-card" (click)="download('player_android_sign_watchdog')">
                    <mat-icon class="platform-icon android-icon">android</mat-icon>
                    <div class="service-content">
                        <h4>Android SignService</h4>
                        <p>For SignPlayer PWA</p>
                    </div>
                    <mat-icon class="download-icon">download</mat-icon>
                </div>

                <div class="service-card" (click)="download('player_windows_sign_watchdog')">
                    <mat-icon class="platform-icon windows-icon">desktop_windows</mat-icon>
                    <div class="service-content">
                        <h4>Windows SignService</h4>
                        <p>For SignPlayer PWA</p>
                    </div>
                    <mat-icon class="download-icon">download</mat-icon>
                </div>

                <div class="service-card coming-soon" (click)="download('player_linux_sign_watchdog')">
                    <mat-icon class="platform-icon linux-icon">computer</mat-icon>
                    <div class="service-content">
                        <h4>Linux SignService</h4>
                        <p>Ubuntu - Coming Soon</p>
                    </div>
                    <mat-icon class="download-icon">schedule</mat-icon>
                </div>
            </div>

            <div class="info-note">
                <mat-icon>info</mat-icon>
                <p>
                    <strong>NOTE:</strong> SignService download link is also available from within the player's Info Box by clicking the Gear icon of the Player's Sidebar.
                </p>
            </div>

            <!-- Toggle Legacy Button -->
            <button mat-stroked-button class="legacy-toggle-btn" (click)="toggleLegacyDownloads()">
                <mat-icon>{{ showLegacyDownloads ? 'expand_less' : 'expand_more' }}</mat-icon>
                <span>{{ showLegacyDownloads ? 'Hide' : 'Show' }} Legacy Versions</span>
            </button>

            <!-- Legacy Downloads Section -->
            @if (showLegacyDownloads) {
            <div class="legacy-section">
                <div class="legacy-header">
                    <mat-icon>history</mat-icon>
                    <h3>Legacy Versions</h3>
                    <span class="deprecated-badge">Deprecated</span>
                </div>

                <p class="legacy-description">Previous versions of SignagePlayer AIR</p>

                <div class="legacy-downloads">
                    <div class="legacy-card" (click)="download('player_exe')">
                        <mat-icon class="platform-icon">desktop_windows</mat-icon>
                        <div class="legacy-content">
                            <h4>SignagePlayer.exe</h4>
                            <p>Windows (32/64 bit)</p>
                        </div>
                        <mat-icon class="download-icon">download</mat-icon>
                    </div>

                    <div class="legacy-card" (click)="download('player_legacy_apk')">
                        <mat-icon class="platform-icon">android</mat-icon>
                        <div class="legacy-content">
                            <h4>SignagePlayer.apk v1</h4>
                            <p>Legacy ADX and older Android players prior to Android 9.x</p>
                        </div>
                        <mat-icon class="download-icon">download</mat-icon>
                    </div>

                    <div class="legacy-card" (click)="download('player_android_watchdog_v2')">
                        <mat-icon class="platform-icon">android</mat-icon>
                        <div class="legacy-content">
                            <h4>Android Watchdog v2</h4>
                            <p>For ADZ and Android 9.X and later</p>
                        </div>
                        <mat-icon class="download-icon">download</mat-icon>
                    </div>

                    <div class="legacy-card" (click)="download('player_android_watchdog_v1')">
                        <mat-icon class="platform-icon">android</mat-icon>
                        <div class="legacy-content">
                            <h4>Android Watchdog v1</h4>
                            <p>For legacy SignagePlayer / ADX and older Android players</p>
                        </div>
                        <mat-icon class="download-icon">download</mat-icon>
                    </div>

                    <div class="legacy-card" (click)="download('player_air')">
                        <mat-icon class="platform-icon">laptop_mac</mat-icon>
                        <div class="legacy-content">
                            <h4>SignagePlayer.air</h4>
                            <p>Mac OSX (32 bit) - Requires AIR installer</p>
                        </div>
                        <mat-icon class="download-icon">download</mat-icon>
                    </div>

                    <div class="legacy-card" (click)="download('player_air')">
                        <mat-icon class="platform-icon">desktop_windows</mat-icon>
                        <div class="legacy-content">
                            <h4>SignagePlayer.air</h4>
                            <p>Windows (32/64 bit) - Requires AIR installer</p>
                        </div>
                        <mat-icon class="download-icon">download</mat-icon>
                    </div>

                    <div class="legacy-card" (click)="download('player_linux')">
                        <mat-icon class="platform-icon">computer</mat-icon>
                        <div class="legacy-content">
                            <h4>SignagePlayer for Linux</h4>
                            <p>Deprecated - Limited support</p>
                        </div>
                        <mat-icon class="download-icon">download</mat-icon>
                    </div>
                </div>
            </div>
            }
        </div>
    </div>
</ngx-flicking>
<ng-template let-modal #installModal>
    <div class="section-header" mat-dialog-title>
        <mat-icon class="section-icon">android</mat-icon>
        <span class="section-title">{{ 'ai.manual' | transloco }} {{ 'ai.installation' | transloco }} {{ 'ai.for' | transloco }} Android</span>
        <button mat-icon-button class="close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content>
        <div fxLayout="row" fxLayoutAlign="center center">
            <button mat-raised-button (click)="download('mediadroid')" style="padding: 10px; margin: 20px; width: 100%" color="warn">
                <mat-icon class="hide-lt-md">star</mat-icon>
                for best performance & reliability get the mediaDROID+
            </button>
        </div>
        <div class="compat">
            <div>
                <div>
                    <br/>
                    <mat-label class="minHead">🚀 Direct installation of SignPlayer on Android with no Preinstalled Chrome on the device such as Google TV and Fire TV</mat-label>
                    <hr/>
                    <div class="installation-steps">
                        <ol style="line-height: 1.8; margin: 20px 0;">
                            <li>
                                📱 Download and install Chrome from <a href="https://play.google.com/store/apps/details?id=com.android.chrome" target="_blank" class="linkGoToDownload hover-link">Google Play Store</a> or get the APK from <a href="https://www.apkmirror.com/apk/google-inc/chrome/" target="_blank" class="linkGoToDownload hover-link">https://www.apkmirror.com/apk/google-inc/chrome/</a>.
                                <br/><small style="opacity: 0.8;">Make sure to choose arm64-v8a + armeabi-v7a architecture and its an APK and not BUNDLE<br/>
                                (Last tested on Google Chrome 138.0.7204.168 (arm64-v8a + arm-v7a) (Android 8.0+))</small>
                            </li>
                            <li>
                                ⬇️ Download and install SignService from <a href="https://galaxy.signage.me/deploy/android/signService.apk" target="_blank" class="linkGoToDownload hover-link">https://galaxy.signage.me/deploy/android/signService.apk</a>
                            </li>
                            <li>
                                ✅ On launch, click each check list item's Allow button to enable permissions.<br/>
                                <small style="opacity: 0.8;">Note that not all permissions is available on all devices - check the Dialog box and see Note if said permission is applicable for the device you are installing.</small>
                            </li>
                            <li>
                                🌐 When done, click Start SignPlayer - Chrome will open and will show the install page. If you are asked which App to use and SignPlayer is not in the selection, choose Chrome then click Just Once.
                            </li>
                            <li>
                                📺 For Google TV and Fire TV, using the mouse, click on the SignPlayer link - this will install SignPlayer.
                            </li>
                            <li>
                                🔄 After SignPlayer is installed, restart the device.
                            </li>
                            <li>
                                🎯 On boot, SignService will kick and may ask which App to launch. Choose SignPlayer and this time choose Always.
                            </li>
                            <li>
                                ✨ Installation is complete. Register your player if you have not yet done so.
                            </li>
                        </ol>
                    </div>
                    <br/>
                </div>
            </div>
<!--            <div>-->
<!--                <fa-icon style="position:relative; top: 4px" size='lg' class="watchdog" [icon]="faAndroid"></fa-icon>-->
<!--                <span class="minHead">SignPlayer and watchdog are also compatible these Android devices:</span>-->
<!--                <hr/>-->
<!--                <ul class="">-->
<!--                    <li>Google TV</li>-->
<!--                    <li>Fire TV</li>-->
<!--                    <li>Android TV</li>-->
<!--                    <li>Android Car</li>-->
<!--                    <li>Google Chrome OS Flex</li>-->
<!--                    <li>Google Chromecast</li>-->
<!--                    <li>Microsoft Windows (latest)</li>-->
<!--                    <li>Apple Mac</li>-->
<!--                    <li>Linux (Ubuntu tested)</li>-->
<!--                    <li>Amazon Fire stick</li>-->
<!--                    <li>TCL TV</li>-->
<!--                    <li>Sony Bravia TV</li>-->
<!--                    <li>Samsung Android TV</li>-->
<!--                    <li>Nvidia Shield (latest)</li>-->
<!--                    <li>Raspberry PI</li>-->
<!--                    <li>iPad (check version with support)</li>-->
<!--                    <li>iPhone (check version with support)</li>-->
<!--                    <li>Browser / Web embedded</li>-->
<!--                </ul>-->
<!--            </div>-->
        </div>
    </div>
</ng-template>
